export { RippleDirective } from './ripple-effect.directive';
export { RippleModule } from './ripple.module';



// WEBPACK FOOTER //
// ./src/app/typescripts/free/ripple/index.ts